import { createAction } from '@ngrx/store';

export const ROOT_ACTIONS = {
  reset: '[Root] Reset State'
};

export class RootActions {
  static reset = createAction(ROOT_ACTIONS.reset);
}
